import {
  PaginatedReturnUserListReadable,
  ReturnUserReadable,
  UsersListData,
  usersListInfiniteOptions
} from '@crm/api'
import { useCapabilities } from '@crm/hooks/useCapabilities'
import { userTransformResults } from '@crm/utils'
import { Text } from '@shared/components'
import { SelectProps } from 'antd'

import { InfiniteSelect } from '../InfiniteSelect'

type Props = {
  /**
   * Name shown instead of the select to roles that may not assign — the field
   * then only reports who is responsible.
   */
  fallbackName?: string
  /** sso_id floated to the top of the list, usually the current user's. */
  preference?: string | null
} & SelectProps

/**
 * The responsible-person field of a lead, in either of its two forms: a user
 * select for roles that may assign, and the responsible's name for those that
 * may not.
 *
 * Meant to sit inside the Form.Item it belongs to, so that the read-only form
 * keeps the field's value and still submits it — rendering nothing there would
 * drop the owner from the payload.
 */
export const ResponsibleField = ({
  fallbackName,
  preference,
  ...props
}: Props) => {
  const { canAssignLeads } = useCapabilities()

  if (!canAssignLeads) return <Text>{fallbackName || '-'}</Text>

  return (
    <InfiniteSelect<
      UsersListData,
      PaginatedReturnUserListReadable,
      ReturnUserReadable
    >
      popupMatchSelectWidth
      getQueryFunction={usersListInfiniteOptions}
      getOptions={({ options }) => userTransformResults(options)}
      // A lead's responsible must be an active user, so archived ones are not
      // worth offering — the backend rejects them.
      baseOptions={{
        query: {
          archived: false,
          preference: preference ? [preference] : undefined
        }
      }}
      {...props}
    />
  )
}
